import {useMutation, useQueryClient} from '@tanstack/react-query';

import {trustAccountKeys} from '@/features/trust-accounts/hooks';
import {useApiClient} from '@/hooks';

import {trustAccountGuestsApi} from '../api';

import type {InviteTrustAccountGuestsPayload} from '@sollapay/types';

interface AccountScoped {
  trustAccountId: string;
}

interface GuestScoped extends AccountScoped {
  guestId: string;
}

export function useTrustAccountGuestMutations() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  const onSuccess = async (_data: unknown, {trustAccountId}: AccountScoped) => {
    await queryClient.invalidateQueries({queryKey: trustAccountKeys.guests(trustAccountId)});
  };

  const invite = useMutation({
    mutationFn: ({trustAccountId, ...payload}: AccountScoped & InviteTrustAccountGuestsPayload) =>
      trustAccountGuestsApi.inviteGuests(client, trustAccountId, payload),
    onSuccess
  });

  const remove = useMutation({
    mutationFn: ({trustAccountId, guestId}: GuestScoped) =>
      trustAccountGuestsApi.removeGuest(client, trustAccountId, guestId),
    onSuccess
  });

  const resend = useMutation({
    mutationFn: ({trustAccountId, guestId}: GuestScoped) =>
      trustAccountGuestsApi.resendInvite(client, trustAccountId, guestId),
    onSuccess
  });

  return {invite, remove, resend};
}
